import React, { Component } from 'react';
import config from './../../../config';
import { forEach } from 'lodash';
import common from './../../../common';
import OutsideNotifier from '../../../OutsideNotifier';
import {
    getLeaguesData,
    getPublicLeaguesData
} from './../../../actions/LeagueActions';
import { connect } from 'react-redux';

class LeagueNew extends Component {

    componentDidMount() {

    }

    onRedirectTo(sPath, trackEvent) {
        // let sRedirect = (sPath + (jLeagueId ? jLeagueId : ''));
        //romit
        let sRedirect = sPath;
        if (trackEvent) {
            common.customTracking(trackEvent);
        }

        if (this.props.GdPointsCal && this.props.GdPointsCal >= config.knoctOutGD) {
            //check if leagues data is stored
            const publicLeagues = common.getLocalStorage('publicLeagues') || [];
            let typeId = "4";
            let countryId = common.getDataFromCookie('CountryId');
            let clubId = 0;
            //check if the mentioned type id isavailable in the legaues
            let leagueIsMentioned = false;
            //get the GdPointsCal flag 

            if (publicLeagues && publicLeagues.length > 0) {
                forEach(publicLeagues, function (value) {
                    if (value.TypeId == typeId) {
                        leagueIsMentioned = true;
                    }
                });
            }
            if (publicLeagues && publicLeagues.length > 0 && leagueIsMentioned) {

                this.props.onRedirectTo(`${"/public-leaderboard/" + typeId + "/" + countryId + "/" + clubId}`);
            } else {
                const GUID = common.getGUID();
                const CountryId = common.getDataFromCookie('CountryId');
                const FavTeamId = common.getDataFromCookie('FavSoccerTeamId');
                this.props.getPublicLeaguesData(GUID, CountryId, FavTeamId, config.CURRENT_LANGUAGE).then(() => {
                    this.props.onRedirectTo(`${"/public-leaderboard/" + typeId + "/" + countryId + "/" + clubId}`);
                })
            }
        } else {
            this.props.onRedirectTo(sRedirect);
        }

    }




    render() {
        let trans = this.props.trans;
        return (<div className="si-card si-card__eot si-restart">
            <div className="si-card__eot-ct">
                <div className="si-mt-text-title">
                    { trans.newLeagueIntro
                        ? trans.newLeagueIntro
                        : "Introduction the" } <span className="si-stars">  { trans.new
                            ? trans.new
                            : "NEW" }</span> { trans.leagueName
                                ? trans.leagueName
                                : "leagueName" }
                </div>
                <div className="si-text-descp">
                    { trans.newLeaguesDescp
                        ? trans.newLeaguesDescp
                        : "To celebrate the Champions League return, we’ve set up a new league exclusively for the remaining matches. Ready to finish strongly?" }
                </div>

                <div className="button-block" onClick={ () => {
                    common.customTracking('Fantasy Football - Leagues');

                    this.onRedirectTo('/leagues/', 'Leagues Card New')
                } }>
                    <div className="si-btn btn-lg"> { trans.newLeaguesButtonTxt
                        ? trans.newLeaguesButtonTxt
                        : "View the league" }</div>
                </div>
            </div>
        </div>)


    }
}


const mapDispatchToProps = (dispatch) => {
    return {
        getPublicLeaguesData: (GUID, CountryId, FavTeamId, LangCode) => dispatch(getPublicLeaguesData(GUID, CountryId, FavTeamId, LangCode)),
    };
};
const mapStateToProps = (state) => {

    return {

    };
};
export default (connect(mapStateToProps, mapDispatchToProps)(LeagueNew));


// WEBPACK FOOTER //
// ./src/components/home/cards/LeagueNew.js